import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import EducacaoService from '../../../../../../services/educacao-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const DocEduc = () => {
    let { id } = useParams()

    const [categoria, setCategoria] = useState("");
    const [referencia, setReferencia] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchDocumento(id) {
        const response = await EducacaoService.educEditDocumentos(id);
        setCategoria(response.data["categoria"]);
        setReferencia(response.data["referencia"]);
        setAno(response.data["ano"]);
    }

    useEffect(() => {
        fetchDocumento(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const documento = await EducacaoService.editarDocumentos(id, {
                categoria: categoria,
                referencia: referencia,
                ano: ano
            })
            if (documento.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option value={categoria}>{categoria}</option>
                                        <option value="Parecer Conclusivo Conselho Municipal do FUNDEB sobre a Prestação de Contas">Parecer Conclusivo Conselho Municipal do FUNDEB sobre a Prestação de Contas</option>
                                        <option value="Ata do Conselho de Educação">Ata do Conselho de Educação</option>
                                        <option value="Ata do Conselho de Alimentação Escolar">Ata do Conselho de Alimentação Escolar</option>
                                        <option value="Plano Municipal de Educação">Plano Municipal de Educação</option>
                                        <option value="Relatório Anual da Gestão">Relatório Anual da Gestão</option>
                                        <option value="Cadastro Único da Creche Municipal">Cadastro Único da Creche Municipal</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="Referência">
                                <FloatingLabel
                                    label="Referência"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Referência"
                                        name="referencia"
                                        onChange={e => setReferencia(e.target.value)}
                                    >
                                        <option value={referencia}>{referencia}</option>
                                        <option value="1º Quadrimestre">1º Quadrimestre</option>
                                        <option value="2º Quadrimestre">2º Quadrimestre</option>
                                        <option value="3º Quadrimestre">3º Quadrimestre</option>
                                        <option value="2022-2025">2022-2025</option>
                                        <option value="2026-2029">2026-2029</option>
                                        <option value="Janeiro">Janeiro</option>
                                        <option value="Fevereiro">Fevereiro</option>
                                        <option value="Março">Março</option>
                                        <option value="Abril">Abril</option>
                                        <option value="Maio">Maio</option>
                                        <option value="Junho">Junho</option>
                                        <option value="Julho">Julho</option>
                                        <option value="Agosto">Agosto</option>
                                        <option value="Setembro">Setembro</option>
                                        <option value="Outubro">Outubro</option>
                                        <option value="Novembro">Novembro</option>
                                        <option value="Dezembro">Dezembro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/educacao/documentos/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Documento editado com sucesso!</Alert>
                <Navigate to={'/restrito/educacao/documentos/listar'} />
            </Fragment>
        )
    }
}

export default DocEduc;